import CardCommon from '@/pages/opinion/components/CardCommon';
import KeywordBox from '@/pages/opinion/pages/feeds/components/KeywordBox';
import { getFeedsKeyword, getFeedsStats } from '@/pages/opinion/services';
import React, { useEffect, useMemo, useState } from 'react';
import { Col, Row } from 'tea-component';
export default function DetailKeyword({
  setSelectRenderKeyword,
  filter,
  selectKeyword,
  setSelectKeyword,
  tableTotal = 0,
  handleStatsData,
  backCommentTotal = () => { },
  commentLoading = false,
  needBrandHealth = false,
  feedsStatsLoading,
  setFeedsStatsLoading,
  contentCard = false,
  GptBtnElement = null
}: {
  setSelectRenderKeyword: any;
  tableTotal: number;
  filter: any;
  selectKeyword: any;
  setSelectKeyword: any;
  backCommentTotal: (value: number) => void;
  handleStatsData?: any;
  commentLoading?: boolean;
  needBrandHealth?: boolean;
  feedsStatsLoading: boolean;
  setFeedsStatsLoading: (value: boolean) => void;
  contentCard?: boolean;
  GptBtnElement?: JSX.Element | any;
}) {
  const [feedsKeyword, setFeedsKeyword] = useState<any>([]);
  const [feedsStats, setFeedsStats] = useState<any>({});

  const [feedsKeywordLoading, setFeedsKeywordLoading] = useState<boolean>(true);

  const fetchKeyword = async (params: any) => {
    setFeedsKeywordLoading(true);
    const keyword = await getFeedsKeyword({ ...params });
    setFeedsKeyword(keyword);
    setFeedsKeywordLoading(false);
  };
  const fetchStats = async (params: any, updateCommentTotal = true) => {
    if (updateCommentTotal) {
      const stats = await getFeedsStats({ ...params });
      handleStatsData?.(stats);
      backCommentTotal(stats?.total || 0);
    } else {
      setFeedsStatsLoading(true);
      const stats = await getFeedsStats({ ...params });
      backCommentTotal(stats?.total || 0);
      handleStatsData?.(stats);
      setFeedsStats(stats);
      setFeedsStatsLoading(false);
    }
  };

  const params = useMemo(
    () => ({
      ...filter,
      translated_to: 'origin',
      statistics_field: filter?.dataType || 'keyword',
      keyword: selectKeyword,
    }),
    [filter, selectKeyword],
  );

  const fetchData = (updateCommentTotal = false) => {
    !updateCommentTotal && fetchKeyword({ ...params });
    fetchStats({ ...params }, updateCommentTotal);
  };

  useEffect(() => {
    if (!filter?.edition_unified_id) return;

    fetchData();
  }, [filter]);

  useEffect(() => {
    if (!filter?.edition_unified_id) return;

    fetchData(true);
  }, [selectKeyword]);

  return (
    <Row className="details-card">
      <Col>
        <CardCommon
          loadingHeight={220}
          contentCard={contentCard}
          loading={feedsKeywordLoading || feedsStatsLoading}
        >
          <KeywordBox
            keywords={feedsKeyword}
            data={feedsStats}
            needBrandHealth={needBrandHealth}
            tableTotal={tableTotal}
            commentLoading={commentLoading}
            // stabled={params?.keyword}
            // autoSelectFirst={params?.keyword}
            keywordChange={({ children, keywordRender }) => {
              setSelectKeyword([...children]);
              setSelectRenderKeyword({
                origin: keywordRender?.keyword,
                zh: keywordRender?.keyword_cn,
                en: keywordRender?.keyword_en,
              });
            }}
            GptBtnElement={GptBtnElement}
          />
        </CardCommon>
      </Col>
    </Row>
  );
}
